import { FC } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import AlertList from '../components/AlertList'

export const AlertRoutes: FC = () => {
 return (
  <Routes>
   <Route path="" element={<Navigate to="new-listing" />} />
   <Route
    path="new-listing"
    element={<AlertList controlType="new_listing_alert" type="forsale" />}
   />
   <Route
    path="sold-listing"
    element={<AlertList controlType="neighbourhood_alert" type="sold" />}
   />
   <Route
    path="open-house-listing"
    element={
     <AlertList controlType="price-open_house_alert" type="openhouse" />
    }
   />
   <Route
    path="price-drop"
    element={<AlertList controlType="price_drop_alert" type="price-drop" />}
   />
  </Routes>
 )
}
